import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";
import * as Turbo from "@hotwired/turbo";
// eslint-disable-next-line no-unused-vars
import * as bootstrap from "bootstrap";

Turbo.start();
const application = Application.start();
const controllers = import.meta.glob("../controllers/*_controller.js", { eager: true });
registerControllers(application, controllers);
